import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { AiOutlineArrowLeft } from "react-icons/ai";
import axios from "axios";
import endPoint from "../redux/EndPoint/endpoint";
import WebsiteFooter from "../Fotter";

function ViewAllBrand() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showAllBrand, setShowAllBrand] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const getBrand = async () => {
      setLoading(true);
      try {
        const res = await axios.get(endPoint.GetBrandWeb);
        setShowAllBrand(res?.data);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.error("Error fetching brand data:", error.message);
      }
    };
    getBrand();
  }, [dispatch]);

  const _handleClick = (name) => {
    const url = `/brand/${name.name}/${name._id}`;
    navigate(url);
  };

  useEffect(() => {
    const script1 = document.createElement("script");
    script1.src = "https://www.googletagmanager.com/gtag/js?id=AW-16647750621";
    script1.async = true;
    document.head.appendChild(script1);

    script1.onload = () => {
      const script2 = document.createElement("script");
      script2.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'AW-16647750621');
      `;
      document.head.appendChild(script2);
    };

    return () => {
      const scripts = document.querySelectorAll(
        'script[src="https://www.googletagmanager.com/gtag/js?id=AW-16647750621"]'
      );
      scripts.forEach((script) => script.remove());
    };
  }, []);

  return (
    <div className="  min-h-screen">
      <div className="sm:mt-36 mt-16 flex mx-auto justify-center items-center  w-[90%]  justify-between ">
        <button
          onClick={() => navigate(-1)}
          className="mr-2 bg-gray-200 px-2 py-2  rounded-full flex items-center sm:block hidden"
        >
          <AiOutlineArrowLeft className="text-lg mr-1" />
        </button>
        <h1 className="text-lg m font-bold   text-center">View All Brands</h1>
        <h1></h1>
      </div>
      <div className="grid grid-cols-3 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 xl:grid-cols-8 gap-5 mt-5  w-[95%] p-2 mx-auto">
        {/* {showAllBrand?.map((category, index) => (
          <div
            key={index}
            onClick={() => _handleClick(category)}
            className="flex flex-col items-center p-1 cursor-pointer rounded-lg bg-white hover:shadow-lg transition-shadow "
          >
            <img
              src={category.image}
              alt={category.name}
              className="w-16 h-16 rounded-full object-cover border border-gray-200"
            />
            <p className="text-center font-medium text-gray-700 line-clamp-1">
              {category.name}
            </p>
          </div>
        ))} */}

        {loading ? (
          <div className="flex justify-center items-center h-[200px] w-full">
            <p className="text-center text-lg font-semibold">Loading...</p>
          </div>
        ) : showAllBrand?.length > 0 ? (
          showAllBrand.map((category, index) => (
            <div
              key={index}
              onClick={() => _handleClick(category)}
              className="flex flex-col items-center p-1 cursor-pointer rounded-lg bg-white hover:shadow-lg transition-shadow"
            >
              <img
                src={category.image}
                alt={category.name}
                className="w-16 h-16 rounded-full object-cover border border-gray-200"
              />
              <p className="text-center font-medium text-gray-700 line-clamp-1">
                {category.name}
              </p>
            </div>
          ))
        ) : (
          <div className="flex justify-center items-center h-[200px] w-full">
            <p className="text-center text-lg font-semibold">No Brands Found</p>
          </div>
        )}
      </div>
      <WebsiteFooter />
    </div>
  );
}

export default ViewAllBrand;
